import React from 'react';

const Contact = () => {
  return (
    <div className="container-fluid text-dark p-5" style={{ backgroundColor: '#E6EBF0' }}>
      <h2 className="text-center mb-4">Contact Us</h2>
      <div className="row">
        <div className="col-md-6 text-center">
          <h4>Application Form</h4>
          <p>
            <a href="https://forms.gle/UZcVg2ZYw23tkxH5A" target="_blank" rel="noopener noreferrer" className="btn btn-lg fw-bold text-white" style={{ backgroundColor: '#8A2BE2', borderColor: '#8A2BE2' }}>
              Application Form
            </a>
          </p>
        </div>
        <div className="col-md-6 text-center">
          <h4>Email</h4>
          <p>
            <a href="mailto:mcn.shah.6@gmail.com" className="btn btn-lg btn-secondary fw-bold">
              Email Us
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
